import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Select from '../../ui/Select/Select'
import StatusDot from '../IssueStatuses/StatusDot'

const renderStatusOption = option => <StatusDot color={option.color} label={option.label} />

const StatusSelect = ({ inputId, issueStatuses, value = null, onChange }) => {
  const options = issueStatuses.map(status => ({
    value: status.id, label: status.name, color: status.color
  }))
  const selected = options.find(option => option.value === value) || null

  const handleChange = useCallback(option => onChange(option?.value ?? null), [onChange])

  return (
    <Select
      formatOptionLabel={renderStatusOption}
      inputId={inputId}
      isSearchable={false}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      options={options}
      value={selected}
      onChange={handleChange}
    />
  )
}

StatusSelect.propTypes = {
  inputId: PropTypes.string,
  issueStatuses: PropTypes.arrayOf(PropTypes.shape({
    color: PropTypes.string,
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })),
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number
}

StatusSelect.defaultProps = {
  inputId: null,
  issueStatuses: [],
  value: null
}

export default StatusSelect
